import client from '@/http'

// const generateAccessCode = (context, reportId) => {
//   client.get(
//     `reports/generateAccessCode/${reportId}`
//   ).then(
//     (res) => {
//       context.commit('SET_ACCESS_CODE', res.data)
//     }
//   ).catch(
//     (err) => {
//       console.error(err)
//     }
//   )
// }

const save = (context) => {
  if (context.state.accessCode.id) {
    client.put(
      `accessCodes/${context.state.accessCode.id}`
    ).then(
      (res) => {
        context.commit('SET_ACCESS_CODE', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  } else {
    client.post(
      'accessCodes',
      {
        bundleId: context.rootGetters['bundles/bundle'].id,
        reportId: context.rootGetters['reports/report'].id
      }
    ).then(
      (res) => {
        context.commit('SET_ACCESS_CODE', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  }
}

const load = (context, params) => {
  client.get(
    `accessCodes/find/${params.bundleId}/${params.reportId}`
  ).then(
    (res) => {
      context.commit('SET_ACCESS_CODE', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const regenerate = (context) => {
  client.put(
    `accessCodes/${context.state.accessCode.id}/regenerate`
  ).then(
    (res) => {
      context.commit('UPDATE', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const revoke = (context) => {
  client.delete(
    `accessCodes/${context.state.accessCode.id}`
  ).then(
    () => {
      context.commit('REVOKE')
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

export default {
  load,
  save,
  revoke,
  regenerate
}
